import { render, staticRenderFns } from "./LandingImage.vue?vue&type=template&id=515e66d0&scoped=true&"
import script from "./LandingImage.vue?vue&type=script&lang=js&"
export * from "./LandingImage.vue?vue&type=script&lang=js&"
import style0 from "./LandingImage.vue?vue&type=style&index=0&id=515e66d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515e66d0",
  null
  
)

export default component.exports